// Light/dark theme via the `dark` class on <html> (tailwind darkMode: "class").
const KEY = "growthai_theme";

export function applyStoredTheme() {
  const stored = localStorage.getItem(KEY);
  const dark = stored
    ? stored === "dark"
    : window.matchMedia?.("(prefers-color-scheme: dark)").matches;
  document.documentElement.classList.toggle("dark", !!dark);
}

export function toggleTheme() {
  const dark = document.documentElement.classList.toggle("dark");
  localStorage.setItem(KEY, dark ? "dark" : "light");
  return dark;
}

export function isDark() {
  return document.documentElement.classList.contains("dark");
}
